import { useDispatch, useSelector } from "react-redux"
import { v4 as uuidv4 } from "uuid"
import { SET_CURRENT_VALUES } from "../../store/fields/actions"
import { InputProps } from "../../types/interfaces"
import { Required } from "../UI/Required"
import TextError from "../UI/TextError"
import React, { KeyboardEvent, useState } from "react"
import { parseDimensions } from "../../helpers/parseDimensions"

const MultipleInputText: React.FC<InputProps> = (props) => {
    const { propertyContainer, textError, group } = props

    const state = useSelector((state: { [key: string]: any }) => state)

    const dispatch = useDispatch()

    const [dimensionsValue, setDimensionsValue] = useState("")

    const isDimensionAttribute = ["Ширина", "Высота", "Глубина"].includes(
        state.fields.currentValues[group]?.name
    )

    const defaultEmptyFieldsList = [...Array(3)].reduce(
        (prev, curr) => ({
            ...prev,
            [uuidv4()]: "",
        }),
        {}
    )
    const currentItems =
        state.fields.currentValues[group][propertyContainer.getName()] ||
        defaultEmptyFieldsList

    const isInvalid = textError && "is-invalid"

    const addValuesHandler = () => {
        dispatch(
            SET_CURRENT_VALUES(
                {
                    [propertyContainer.getName()]: {
                        ...currentItems,
                        [uuidv4()]: "",
                    },
                },
                group
            )
        )
    }

    const addDimensionsHandler = () => {
        const dimensions = parseDimensions(dimensionsValue)

        if (!dimensions.length) {
            return
        }

        const existingValues = new Set(
            Object.values(currentItems).map(String)
        )

        const newItems = { ...currentItems }

        dimensions.forEach((dimension) => {
            const value = String(dimension)

            if (!existingValues.has(value)) {
                newItems[uuidv4()] = value
                existingValues.add(value)
            }
        })

        dispatch(
            SET_CURRENT_VALUES(
                {
                    [propertyContainer.getName()]: newItems,
                },
                group
            )
        )

        setDimensionsValue("")
    }

    const dimensionsKeyDownHandler = (
        event: KeyboardEvent<HTMLInputElement>
    ) => {
        if (event.key === "Enter") {
            event.preventDefault()
            addDimensionsHandler()
        }
    }

    const inputHandler = (
        index: any,
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        currentItems[index] = event.target.value
        dispatch(
            SET_CURRENT_VALUES(
                { [propertyContainer.getName()]: currentItems },
                group
            )
        )
    }

    const renderingValues = Array.isArray(currentItems)
        ? [...currentItems]
        .sort((a, b) => {
            const valueA = Number(a)
            const valueB = Number(b)

            if (Number.isNaN(valueA) && Number.isNaN(valueB)) {
                return String(a).localeCompare(String(b))
            }

            if (Number.isNaN(valueA)) return 1
            if (Number.isNaN(valueB)) return -1

            return valueA - valueB
        })
        .map((item: string, index: number) => {
              if (item === null) return null

              console.warn(item)
              return (
                  <div className="row" key={index}>
                      <div className="col direct-breadcrumbs">
                          <input
                              className={`form-control ${isInvalid}`}
                              type={
                                  propertyContainer.getType() ===
                                  "multipleNumber"
                                      ? "number"
                                      : "text"
                              }
                              id={`${index}`}
                              value={item}
                              name={`${propertyContainer.getName()}[${index}]`}
                              placeholder={propertyContainer.get("placeholder")}
                              disabled={propertyContainer.get("readonly")}
                              onChange={(event) => {
                                  inputHandler(index, event)
                              }}
                          />
                          {textError && <TextError text={textError} />}
                      </div>
                  </div>
              )
          })
        : Object.keys(currentItems)
            .sort((a, b) => {
                const itemA = currentItems[a]
                const itemB = currentItems[b]

                if (itemA === '' && itemB === '') return 0
                if (itemA === '') return 1
                if (itemB === '') return -1

                const valueA = Number(itemA)
                const valueB = Number(itemB)

                if (Number.isNaN(valueA) && Number.isNaN(valueB)) {
                    return String(itemA).localeCompare(String(itemB))
                }

                if (Number.isNaN(valueA)) return 1
                if (Number.isNaN(valueB)) return -1

                return valueA - valueB
            })
            .map((index) => {
              const item = currentItems[index]
              if (item === null) return null
              console.warn(item)
              return (
                  <div className="row" key={index}>
                      <div className="col direct-breadcrumbs">
                          <input
                              className={`form-control ${isInvalid}`}
                              type={
                                  propertyContainer.getType() ===
                                  "multipleNumber"
                                      ? "number"
                                      : "text"
                              }
                              id={`${index}`}
                              value={item}
                              name={`${propertyContainer.getName()}[${index}]`}
                              placeholder={propertyContainer.get("placeholder")}
                              disabled={propertyContainer.get("readonly")}
                              onChange={(event) => {
                                  if (
                                      Object.values(currentItems).some(
                                          (el) => el === event.target.value
                                      )
                                  ) {
                                      event.target.classList.add("is-invalid")
                                  } else {
                                      event.target.classList.remove(
                                          "is-invalid"
                                      )
                                  }
                                  inputHandler(index, event)
                              }}
                          />
                          {textError && <TextError text={textError} />}
                      </div>
                  </div>
              )
          })

    return (
        <div className="row mb-3">
            <label
                htmlFor={propertyContainer.getId()}
                className="col-xl-3 col-form-label"
            >
                {propertyContainer.get("required") ? <Required /> : null}
                {propertyContainer.get("label")}
            </label>
            <div
                className="col-xl-9"
                style={{ maxHeight: 300, overflow: "auto" }}
            >
                {isDimensionAttribute && (
                    <div className="row mb-3">
                        <div className="col">
                            <input
                                className="form-control"
                                value={dimensionsValue}
                                placeholder="Например: 100-500*100"
                                onChange={(event) => {
                                    const value = event.target.value.replace(
                                        /[^\d,\-*]/g,
                                        ""
                                    )

                                    setDimensionsValue(value)
                                }}
                                onKeyDown={dimensionsKeyDownHandler}
                            />

                            <div className="form-text">
                                Можно использовать только цифры и символы{" "}
                                <code>,</code>, <code>-</code>, <code>*</code>.
                                <br />
                                Несколько значений: <code>200,350,700</code>.
                                <br />
                                Диапазон с шагом: <code>100-500*100</code> → 100, 200,
                                300, 400, 500.
                                <br />
                                Можно комбинировать:{" "}
                                <code>370,420,100-250*50,1000</code>.
                            </div>
                        </div>

                        <div className="col-auto">
                            <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={addDimensionsHandler}
                            >
                                Добавить
                            </button>
                        </div>
                    </div>
                )}
                {renderingValues}
                <button
                    onClick={addValuesHandler}
                    type="button"
                    className="btn btn-outline-primary"
                >
                    Еще
                </button>
            </div>
        </div>
    )
}

export default MultipleInputText
